import { queryOptions } from '@tanstack/react-query';
import { minutesToMilliseconds } from 'date-fns';

import { fetchAudienceCountries } from 'services/backend/audienceCountries';

export const audienceCountryQueries = {
  list: queryOptions({
    queryFn: () => fetchAudienceCountries(),
    queryKey: ['audienceCountries'],
    staleTime: minutesToMilliseconds(10),
  }),
};
